import { Box } from "@mui/material";
import React, { ReactNode } from "react";
import LabelValueDisplay from "components/LabelValueDisplay";

interface TireInfoSectionProps {
  carImage?: string;
  carModel?: string | ReactNode;
  tireSize?: string;
  tireType?: string;
  sizeSpecification?: string | number;
}

const styles = {
  label: {
    fontSize: { xs: 16, md: 18, lg: 20 },
    backgroundColor: "var(--primary-500)",
    textAlign: "center",
    padding: "10px 0",
    fontWeight: "bold",
  },
  value: {
    textAlign: "center",
    margin: "5px auto",
    fontSize: { xs: 16, md: 18, lg: 20 },
  },
};

/**
 * Component to display tire information section
 * Shows selected vehicle, tire size, type, and size specification
 * @param props - Component props
 */
function TireInfoSection({
  carImage,
  carModel,
  tireSize,
  tireType,
  sizeSpecification,
}: TireInfoSectionProps) {
  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: { xs: "wrap", md: "nowrap" },
        columnGap: 2,
        width: "100%",
      }}
    >
      {/* Car Image */}
      {carImage && (
        <Box
          sx={{
            width: { xs: 'auto', xl: '280px' },
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img src={carImage} alt="Selected Car" width="163px" style={{ height: "98px" }} />
        </Box>
      )}

      {/* Info Grid */}
      <Box sx={{ display: "flex", columnGap: "4px", flexWrap: "wrap", flex: 1 }}>
        {[
          { label: "選択車両", value: carModel },
          { label: "タイヤサイズ", value: tireSize },
          { label: "タイヤ種類", value: tireType },
          { label: "サイズ指定", value: sizeSpecification },
        ].map((item) => (
          <LabelValueDisplay
            key={item.label}
            label={item.label}
            value={item.value as string | number | React.ReactElement}
            type="text"
            containerSx={{ width: "calc((100% - 4px) / 2)" }}
            labelSx={styles.label}
            valueSx={styles.value}
          />
        ))}
      </Box>
    </Box>
  );
}

export default TireInfoSection;
